import React, { useState, useEffect } from 'react';

const PHASES = [
  'Parsing model configuration...',
  'Scanning data security posture...',
  'Evaluating safety guardrails...',
  'Analysing agent governance...',
  'Mapping compliance frameworks...',
  'Running threat vector analysis...',
  'Consulting Claude AI engine...',
  'Generating remediation roadmap...',
  'Compiling executive report...',
];

export default function Loading({ companyName }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setPhase(p => Math.min(p + 1, PHASES.length - 1)), 2400);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--void)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px', position: 'relative', overflow: 'hidden' }}>
      {/* Grid */}
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(124,58,237,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(124,58,237,.05) 1px,transparent 1px)', backgroundSize: '44px 44px' }} />
      {/* Orb */}
      <div style={{ position: 'absolute', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle,rgba(124,58,237,.14) 0%,transparent 70%)', filter: 'blur(70px)', animation: 'pulse 3s ease-in-out infinite' }} />

      {/* Spinner */}
      <div style={{ position: 'relative', width: 150, height: 150, marginBottom: 44 }}>
        <div style={{ position: 'absolute', inset: 0, border: '2px solid transparent', borderTopColor: 'var(--violetbr)', borderRightColor: 'rgba(124,58,237,.25)', borderRadius: '50%', animation: 'spin 1.1s linear infinite' }} />
        <div style={{ position: 'absolute', inset: 18, border: '2px solid transparent', borderTopColor: 'var(--cyan)', borderLeftColor: 'rgba(6,182,212,.2)', borderRadius: '50%', animation: 'spin .75s linear infinite reverse' }} />
        <div style={{ position: 'absolute', inset: 36, background: 'var(--card)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 34, border: '1px solid var(--borderacc)' }}>
          🛡️
        </div>
      </div>

      <h2 style={{ fontFamily: 'var(--ff-display)', fontSize: 34, fontWeight: 800, letterSpacing: '-0.04em', marginBottom: 8, textAlign: 'center', background: 'linear-gradient(135deg,var(--txt),var(--violetbr))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
        Analysing Risk Profile
      </h2>
      <div style={{ fontFamily: 'var(--ff-mono)', fontSize: 14, color: 'var(--violetbr)', marginBottom: 40, textAlign: 'center', minHeight: 22 }} className="fadeup">
        {companyName ? `${companyName} · ` : ''}{PHASES[phase]}
      </div>

      {/* Terminal */}
      <div style={{ background: 'var(--card)', border: '1px solid var(--borderacc)', borderRadius: 18, padding: '22px 26px', width: '100%', maxWidth: 540, fontFamily: 'var(--ff-mono)', fontSize: 12, lineHeight: 1.9 }}>
        {PHASES.map((p, i) => (
          <div key={i} style={{ color: i < phase ? 'var(--emerald)' : i === phase ? 'var(--cyan)' : 'var(--txt3)', display: 'flex', gap: 10, alignItems: 'center' }}>
            <span>{i < phase ? '✓' : i === phase ? '▶' : '○'}</span>
            <span>{p}</span>
            {i === phase && <span style={{ animation: 'blink 1s ease infinite' }}>_</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
